import React, { useState } from 'react';
import axios from 'axios';
import { Sparkles, X, BrainCircuit, Box, Activity, Target } from 'lucide-react';
import { API_URL as CONFIG_API_URL } from '../../config';
const API_URL = CONFIG_API_URL || 'http://8.141.122.155:3002/api';

export default function SeoAiWizardModal({ isOpen, onClose, onComplete }) {
  if (!isOpen) return null;

  const [formData, setFormData] = useState({ brandName: '' });
  const [loading, setLoading] = useState(false);
  const [logs, setLogs] = useState([]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.brandName) return alert('请输入品牌名称！');

    setLoading(true);
    setLogs(['初始化 DeepSeek 商业增长模型...']);
    
    setTimeout(() => setLogs(prev => [...prev, '正在分析行业属性与受众搜索意图...']), 1500);
    setTimeout(() => setLogs(prev => [...prev, '构建 SICAS 消费者旅程漏斗...']), 3000);
    setTimeout(() => setLogs(prev => [...prev, '生成品牌词、通用词、对比词、竞品词 3D 矩阵...']), 4500);
    setTimeout(() => setLogs(prev => [...prev, '正在向战略资产库写入数据，请稍候...']), 7000);

    try {
      const res = await axios.post(`${API_URL}/seo/config/ai-wizard`, {
        brandName: formData.brandName,
        
      }, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      
      setLogs(prev => [...prev, `✅ 成功生成 ${res.data.themesCreated} 个业务词包矩阵！`]);
      setTimeout(() => {
        if(onComplete) onComplete(res.data);
        onClose();
      }, 1500);
    } catch (e) {
      setLogs(prev => [...prev, '❌ 生成失败: ' + (e.response?.data?.error || e.message)]);
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6">
      <div className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm" onClick={!loading ? onClose : undefined}></div>
      <div className="relative bg-white dark:bg-slate-900 w-full max-w-2xl rounded-2xl shadow-2xl overflow-hidden border border-gray-100 dark:border-slate-800 animate-in fade-in zoom-in-95 duration-200">
        
        {/* Header */}
        <div className="p-6 border-b border-gray-100 dark:border-slate-800 flex justify-between items-center bg-gradient-to-r from-emerald-50 to-teal-50 dark:from-emerald-950/30 dark:to-teal-900/30">
          <div className="flex items-center">
            <div className="w-10 h-10 rounded-xl bg-emerald-100 dark:bg-emerald-900/50 flex items-center justify-center mr-4 text-emerald-600 dark:text-emerald-400">
              <Sparkles className="w-5 h-5" />
            </div>
            <div>
              <h2 className="text-xl font-bold text-gray-900 dark:text-white">SEO 智能建项向导</h2>
              <p className="text-sm text-gray-500 dark:text-emerald-400/70 mt-0.5">DeepSeek-V3 引擎驱动 · 自动构建 3D 关键词矩阵</p>
            </div>
          </div>
          <button onClick={!loading ? onClose : undefined} className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors">
            <X className="w-6 h-6" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          {!loading ? (
            <form onSubmit={handleSubmit} className="space-y-5">
              
              <div className="bg-emerald-50 dark:bg-emerald-900/20 rounded-xl p-5 border border-emerald-100 dark:border-emerald-800/30">
                <h3 className="text-sm font-bold text-emerald-800 dark:text-emerald-300 mb-2 flex items-center">
                  <Sparkles className="w-4 h-4 mr-1.5" />
                  全自动黑盒建项模式
                </h3>
                <p className="text-sm text-emerald-600/80 dark:text-emerald-400/80 leading-relaxed">
                  您只需输入品牌名称。AI 将基于其千亿级知识库，自动为您识别所属行业、拆解核心产品线、提取 3 个核心竞品，并直接生成一套立即可用的 3D 关键词矩阵。
                </p>
              </div>

              <div>
                <label className="flex items-center text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">
                  <Box className="w-4 h-4 mr-2 text-indigo-500" /> 品牌名称 (必填)
                </label>
                <input 
                  type="text" 
                  placeholder="例如：小米汽车、元气森林、飞书..."
                  value={formData.brandName}
                  onChange={e => setFormData({...formData, brandName: e.target.value})}
                  className="w-full px-4 py-3 bg-white dark:bg-slate-900 border border-gray-200 dark:border-slate-700 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none transition-all dark:text-white shadow-sm"
                  required
                />
              </div>

              <div className="pt-4 border-t border-gray-100 dark:border-slate-800 flex justify-end space-x-3">
                <button type="button" onClick={onClose} className="px-5 py-2.5 text-sm font-medium text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-slate-800 rounded-xl transition-colors">
                  取消
                </button>
                <button 
                  type="submit" 
                  disabled={!formData.brandName}
                  className="px-6 py-2.5 bg-gradient-to-r from-emerald-500 to-teal-600 hover:from-emerald-600 hover:to-teal-700 text-white rounded-xl text-sm font-medium transition-all shadow-md flex items-center disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <BrainCircuit className="w-4 h-4 mr-2" />
                  开始大模型生成
                </button>
              </div>
            </form>
          ) : (
            <div className="py-12 flex flex-col items-center">
              <div className="relative">
                <div className="w-16 h-16 border-4 border-emerald-100 dark:border-emerald-900/30 rounded-full"></div>
                <div className="w-16 h-16 border-4 border-emerald-500 rounded-full border-t-transparent animate-spin absolute top-0 left-0"></div>
                <Sparkles className="w-6 h-6 text-emerald-500 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 animate-pulse" />
              </div>
              <h3 className="mt-6 text-lg font-bold text-gray-900 dark:text-white">AI 正在构建资产库...</h3>
              
              <div className="mt-8 w-full max-w-md bg-slate-900 rounded-xl p-4 font-mono text-xs text-emerald-400 space-y-2 h-40 overflow-y-auto">
                {logs.map((log, i) => (
                  <div key={i} className="flex items-start animate-in fade-in slide-in-from-bottom-2">
                    <span className="text-slate-500 mr-2">{'>'}</span>
                    <span>{log}</span>
                  </div>
                ))}
                <div className="flex items-start animate-pulse">
                  <span className="text-slate-500 mr-2">{'>'}</span>
                  <span className="w-2 h-3 bg-emerald-400 mt-0.5"></span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
